import React from "react";

const Section13Children = () => (
  <>
    <h2>13. Children's Privacy</h2>
    <p>
    Comparedly.com is not specifically directed at children under the age of 16. We do not knowingly collect personal data from children under this age without obtaining verifiable consent from their parent or legal guardian. If you are a parent or guardian and believe that your child has provided us with personal data without your consent, please contact us immediately at privacy@comparedly.com, and we will take prompt steps to investigate and remove the information from our records.
    </p>
  </>
);

export default Section13Children;
